<div class="dialog-header">
  <!-- <h2 class="dialog-title">Welcome</h2> -->
   <img class="logo" src="../../../../assets/alyn360.png">
  <button mat-icon-button class="close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-tab-group [(selectedIndex)]="selectedIndex" mat-align-tabs="center">
  <mat-tab label="Login">
    <div class="tab-content">
      <app-login></app-login>
    </div>
  </mat-tab>
  <mat-tab label="Register">
    <div class="tab-content">
      <app-register></app-register>
    </div>
  </mat-tab>
</mat-tab-group>
